export default __webpack_public_path__ + "static/media/con-activar.53785eb7.svg";